const blue = {
	50: '#6B8EBF',
	100: '#5B7EAF',
	200: '#4B6E9F',
	300: '#3B5E8F',
	400: '#2B4E7F',
	500: '#1B3E6F',
	600: '#0B2E5F',
	700: '#0B2E5F',
	800: '#0B2E5F',
	900: '#0B2E5F',
	A100: '#1B3E6F',
	A200: '#1B3E6F',
	A400: '#1B3E6F',
	A700: '#1B3E6F',
	contrastDefaultColor: 'light'
};

export default blue;



// WEBPACK FOOTER //
// ./src/client/components/common/material-ui-colors/blue.js